export { default } from './CommunityFeaturesSection'